import { useState } from "react";
import { Check, Copy } from "lucide-react";

// A code sample in a guide: optional title bar (e.g. "Request", "Node.js") and
// a copy button. Plain <pre> — no syntax highlighting, so no extra dependency.
export function CodeBlock({ code, lang, title }: { code: string; lang?: string; title?: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard blocked — the text is still selectable */
    }
  };
  return (
    <figure className="hc-code">
      <figcaption className="hc-code__bar">
        <span className="hc-code__title">{title ?? lang ?? "Example"}</span>
        <button type="button" className="hc-code__copy" onClick={copy} aria-label="Copy code">
          {copied ? <Check size={13} aria-hidden="true" /> : <Copy size={13} aria-hidden="true" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </figcaption>
      <pre className="hc-code__pre" data-lang={lang}>
        <code>{code}</code>
      </pre>
    </figure>
  );
}
